module.exports = __webpack_public_path__ + "img/newLogo.dac167e4.svg";